module.exports = __webpack_public_path__ + "static/media/299.d2a4e6e9.png";